document.addEventListener("DOMContentLoaded", function () {
  const menus = document.querySelectorAll(".ah-common-menu");

  menus.forEach((menu) => {
    const accordionTitles = menu.querySelectorAll(".js-accordion-title");

    accordionTitles.forEach((title) => {
      title.addEventListener("click", function () {
        const level2Item = this.closest(".level2"); // 親の .level2 要素を取得
        const level3Lists = this.nextElementSibling; // 次の .level3-lists を取得

        // .level2 に .open クラスをトグル
        if (level2Item) {
          level2Item.classList.toggle("open");
        }

        // .level3-lists の開閉をトグル
        if (level3Lists && level3Lists.classList.contains("level3-lists")) {
          level3Lists.classList.toggle("open");

          // スタイルの変更（例: max-height でアニメーション）
          if (level3Lists.classList.contains("open")) {
            level3Lists.style.maxHeight = level3Lists.scrollHeight + "px";
          } else {
            level3Lists.style.maxHeight = "0";
          }
        }
      });
    });
  });
});


// 商品説明のタブ
document.querySelectorAll('.ah-desc-tab__list').forEach(tab => {
  tab.addEventListener('click', function() {
    // 全てのタブからアクティブクラスを削除し、全てのコンテンツを非表示にする
    document.querySelectorAll('.ah-desc-tab__list').forEach(t => t.classList.remove('active'));
    document.querySelectorAll('.tab-content').forEach(content => content.classList.remove('active'));

    // クリックしたタブにアクティブクラスを追加し、対応するコンテンツを表示
    const tabId = this.getAttribute('data-tab');
    this.classList.add('active');
    document.getElementById(tabId).classList.add('active');
  });
});


//　ヘッダー　検索モーダル
document.querySelectorAll('.search-button').forEach(function(button) {
  button.addEventListener('click', function() {
    document.querySelectorAll('.ah-search-form').forEach(function(searchForm) {
      searchForm.style.display = (searchForm.style.display === 'none' || searchForm.style.display === '') ? 'block' : 'none';
    });
  });
});

document.querySelectorAll('.ah-search-form__close').forEach(function(closeButton) {
  closeButton.addEventListener('click', function() {
    document.querySelectorAll('.ah-search-form').forEach(function(searchForm) {
      searchForm.style.display = 'none'; // フォームを非表示
    });
  });
});


// TOPページヘッダー　　ハンバーガーメニューの開閉
document.getElementById('ah-header__hamb-icon').addEventListener('click', function() {
  const menu = document.getElementById('ah-header__hamb-menu');
  menu.classList.toggle('active');
  document.body.classList.add("no_scroll");
});

document.getElementById('ah-header__hamb-menu-top-close').addEventListener('click', function() {
  const menu = document.getElementById('ah-header__hamb-menu');
  menu.classList.remove('active');
  document.body.classList.remove("no_scroll");
});


// 2階層目メニューを開く処理
document.getElementById('ah-header__hamb-menu-to-shop').addEventListener('click', function() {
  const secondMenu = document.getElementById('ah-header__hamb-menu-shop');
  
  // 2階層目のメニューをアクティブにする
  secondMenu.classList.add('active');
  
  // もしスライドリセットクラスがあれば削除
  secondMenu.classList.remove('slide-reset');
});

// 2階層目メニューを閉じる処理
document.getElementById('ah-header__hamb-menu-list-reset').addEventListener('click', function() {
  const secondMenu = document.getElementById('ah-header__hamb-menu-shop');
  
  // スライドリセットを実行し、2階層目を閉じる
  secondMenu.classList.add('slide-reset');
  
  // 閉じた後、一定時間後にアクティブ状態を解除（アニメーションが終わるのを待つ）
  setTimeout(function() {
    secondMenu.classList.remove('active');
  }, 300);  // アニメーション時間に合わせて調整
});



// 下層ページヘッダー　　ハンバーガーメニューの開閉
document.getElementById('ah-header__hamb-icon-under').addEventListener('click', function() {
  const menu = document.getElementById('ah-header__hamb-menu-under');
  menu.classList.toggle('active');
  document.body.classList.add("no_scroll");
});

document.getElementById('ah-header__hamb-menu-top-close-under').addEventListener('click', function() {
  const menu = document.getElementById('ah-header__hamb-menu-under');
  menu.classList.remove('active');
  document.body.classList.remove("no_scroll");
});

// 2階層目メニューを開く処理
document.getElementById('ah-header__hamb-menu-to-shop-under').addEventListener('click', function() {
  const secondMenu = document.getElementById('ah-header__hamb-menu-shop-under');
  
  // 2階層目のメニューをアクティブにする
  secondMenu.classList.add('active');
  
  // もしスライドリセットクラスがあれば削除
  secondMenu.classList.remove('slide-reset');
});

// 2階層目メニューを閉じる処理
document.getElementById('ah-header__hamb-menu-list-reset-under').addEventListener('click', function() {
  const secondMenu = document.getElementById('ah-header__hamb-menu-shop-under');
  
  // スライドリセットを実行し、2階層目を閉じる
  secondMenu.classList.add('slide-reset');
  
  // 閉じた後、一定時間後にアクティブ状態を解除（アニメーションが終わるのを待つ）
  setTimeout(function() {
    secondMenu.classList.remove('active');
  }, 300);  // アニメーション時間に合わせて調整
});



// タブメニュー
// document.addEventListener("DOMContentLoaded", function () {
//   // 最初のコンテンツは表示
//   document.querySelector(".js-content").style.display = "block";

//   // タブをクリックすると
//   const tabs = document.querySelectorAll(".js-tab");
//   tabs.forEach((tab, index) => {
//     tab.addEventListener("click", function () {
//       // 現在選択されているタブからcurrentを外す
//       document.querySelector(".current")?.classList.remove("current");

//       // クリックされたタブにcurrentクラスを付与
//       tab.classList.add("current");

//       // すべてのコンテンツを非表示にし、クリックしたタブに対応するコンテンツを表示
//       const contents = document.querySelectorAll(".js-content");
//       contents.forEach(content => content.style.display = "none");
//       contents[index].style.display = "block";
//       contents[index].style.opacity = "0";
      
//       // フェードイン効果
//       let opacity = 0;
//       const fadeIn = setInterval(() => {
//         opacity += 0.05;
//         contents[index].style.opacity = opacity;
//         if (opacity >= 1) clearInterval(fadeIn);
//       }, 30);
//     });
//   });
// });



// Q&Aアコーディオン
document.addEventListener('DOMContentLoaded', function() {
  // 各アコーディオン項目を取得
  const toggles = document.querySelectorAll('.ah-page-qa__toggle');
  
  // クリックイベントを各トグルに設定
  toggles.forEach(function(toggle) {
    toggle.addEventListener('change', function() {
      const content = this.parentNode.querySelector('.ah-page-qa__content');
      
      // トグルのチェック状態に応じてコンテンツを表示または非表示
      if (this.checked) {
        content.style.display = 'block';  // チェックされていれば表示
      } else {
        content.style.display = 'none';   // チェックされていなければ非表示
      }
    });
    
    // 初期状態では非表示に設定
    const content = toggle.parentNode.querySelector('.ah-page-qa__content');
    content.style.display = 'none';
  });
});

